export default "__VITE_ASSET__13421d2a__"